import { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import API, { getImageUrl } from '../utils/api';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    API.get('/settings/logo').then(r => {
      if (r.data?.value) setLogo(getImageUrl(r.data.value));
    }).catch(() => {});
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="navbar-logo">
        {logo 
          ? <img src={logo} alt="The Village Investors Logo" />
          : null
        }
        <span className="navbar-brand">The Village <span>Investors</span></span>
      </Link>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {[
          { path: '/', label: 'Home' },
          { path: '/yourself', label: 'Yourself' },
          { path: '/earth', label: 'Earth' },
          { path: '/stocks', label: 'Stocks' },
          { path: '/generosity', label: 'Generosity' },
          { path: '/videos', label: 'Watch Videos', highlight: true },
        ].map(({ path, label, highlight }) => (
          <li key={path}>
            <NavLink 
              to={path} 
              end={path === '/'}
              className={({ isActive }) => `${isActive ? 'active' : ''} ${highlight ? 'nav-video-link' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {highlight && <span className="nav-video-icon">▶</span>}
              {label}
            </NavLink>
          </li>
        ))}
      </ul>

      <button 
        className={`nav-hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
};

export default Navbar;
